import axios from "axios"
import { VERSION } from "../config";
const _MODULE = `/mall/${VERSION}/mobile/order`;
export default {
  /***
   * 【H5】【订单】订单支付(会员卡和微信)
   */
  h5pay(data) {
    return axios({
      url: `${_MODULE}/h5/pay`,
      method: `POST`,
      data
    })
  }
}


// WEBPACK FOOTER //
// ./src/apis/src/order.js